import styled from "styled-components";

export const GalleryDatepickerContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'Geist Mono', monospace;

  > div:last-child {
    position: relative;

    > div:first-child {
      position: relative;
    }

    input {
      width: auto;
      min-width: 176px;
      text-align: right;
    }

    > div:nth-child(3) {
      position: absolute;
      right: 0;
      top: calc(100% + 8px);
      z-index: 50;

      * {
        font-family: 'Geist Mono', monospace;
      }

      @media (max-width: 768px) {
        min-width: 80vw;
        max-height: 70vh;
        overflow-y: scroll;
        right: auto;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
`;

export const ClearFilterButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  cursor: pointer;
  transition: background 0.2s;
  flex-shrink: 0;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }

  &:active {
    background: rgba(255, 255, 255, 0.4);
  }
`;
